import { useSearchParams } from "react-router-dom";

import { Loader } from "@mantine/core";
import PreviewHeader from "components/header/PreviewHeader";
import AdminOrderPreview from "pages/admin/dataEntry/AdminOrderPreview";

const PrintOrder: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const orderStage = params.get("s");

  if (!id || !orderStage) return <Loader />;
  return (
    <div className="inner-container">
      <PreviewHeader />

      <AdminOrderPreview
        id={Number(id)}
        orderStage={Number(orderStage)}
        invoiceTo={null}
        deliverTo={null}
      />
    </div>
  );
};

export default PrintOrder;
